import { render, staticRenderFns } from "./TableDeleteLessDanger.vue?vue&type=template&id=7cf1d344&"
import script from "./TableDeleteLessDanger.vue?vue&type=script&lang=js&"
export * from "./TableDeleteLessDanger.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports